export default class StringUtil {
  static capitalize(str: string) {
    return str.replace(
      /\w\S*/g,
      (txt) => txt.charAt(0).toUpperCase() + txt.substring(1),
    );
  }

  static dedupe(items: any[], prop: string): any[] {
    return items.reduce((acc: any[], item: any) => {
      if (acc.find((ac) => ac[prop] === item.prop)) {
        return acc;
      }

      return [...acc, item];
    }, []);
  }
}
